import {dateFormat} from 'common/dateFormatterConfig';
import {canSignAgreement} from 'helpers/signer-helper';
import {AGREEMENT_TYPE_MAP, IAgreement} from 'models/agreements';
import moment from 'moment';
import React from 'react';
import {Button, Spinner} from 'react-bootstrap';
import { AgreementInfoColumn } from './AgreementInfoColumn';
import { CustomerPermission, useAuthContext } from 'services/context/authentication.context';

interface OilAgreementCardProps {
    agreement: IAgreement;
    startSigning: () => void;
    getFilePreview: () => void;
    isFilePreviewLoading: boolean;
}

export default function OilAgreementCard({ agreement, getFilePreview, isFilePreviewLoading, startSigning }: OilAgreementCardProps) {

  const { state, hasPermission } = useAuthContext();

  const canSign = !agreement.isSignedByCustomer
    && hasPermission(CustomerPermission.WEB_ADMIN)
    && canSignAgreement(agreement, state.user?.personalIdentificationCode);

    const ActionButtons = (
      <div className="d-flex flex-column flex-lg-row w-100 mx-0">
          <div className="px-lg-2">
              <Button 
                  variant="outline-primary" 
                  size="lg" 
                  block 
                  className="d-flex align-items-center justify-content-center text-nowrap" 
                  disabled={isFilePreviewLoading} 
                  onClick={getFilePreview}
              >
                  {   isFilePreviewLoading &&
                    <Spinner animation="border" className="mr-2" />
                  }
                  Vaata lepingut
              </Button>
          </div>
          { canSign ? (
            <div className="px-lg-2 mt-2 mt-lg-0">
                <Button variant="outline-primary" size="lg" block onClick={startSigning}>Allkirjasta</Button>
            </div>
          ) : null
          }
      </div>
    );

    return (
      <div className="d-flex flex-column bg-white rounded mt-1 mb-2 px-3 px-lg-4 py-5">
          <div className={`d-flex justify-content-between align-items-center w-100`}>
              <div className="d-flex">
                  <i className={`icon__canister icon__canister--masked bg-primary d-inline-block mr-2 mt-1`}></i>
                  <div className="d-flex flex-column">
                      <div className="d-flex flex-column flex-lg-row align-items-lg-center">
                          <h2 className="u-fs-24 font-weight-bold mb-0">
                              {AGREEMENT_TYPE_MAP[agreement.type]} nr { agreement.contractNumber }
                          </h2>
                          {
                            agreement.isSignedByCustomer && (
                                <div className="electricity_agreements__status text-nowrap ml-lg-3 mt-lg-2 mt-4">
                                    <span className="active-status">Kehtiv</span>
                                </div>
                            )
                          }
                      </div>
                  </div>
              </div>
              <div className="d-flex align-items-center">
                  <div className="d-none d-lg-flex">
                      { ActionButtons }
                  </div>
              </div>
          </div>
          <div className="d-flex flex-column">
            <div className="electricity-agreement-card-detailed-info__table">
              <div className="d-flex flex-column flex-lg-row pt-3 pt-lg-0 py-lg-2 ml-3">
                  <AgreementInfoColumn
                      title="Uuendatud:"
                      value={ moment(agreement.dateModified).format(dateFormat) }
                  />
                  <AgreementInfoColumn />
              </div>
            </div>
          </div>
          <div className="d-flex d-lg-none px-2 px-lg-4 my-3">
          <div className="d-flex flex-column flex-lg-row w-100 mx-0">
            <div className="px-lg-2">
                <Button 
                    variant="outline-primary" 
                    size="lg" 
                    block 
                    className="d-flex align-items-center justify-content-center text-nowrap" 
                    disabled={isFilePreviewLoading} 
                    onClick={getFilePreview}
                >
                    {   isFilePreviewLoading &&
                      <Spinner animation="border" className="mr-2" />
                    }
                    Vaata lepingut
                </Button>
            </div>
            { canSign ? (
                <div className="px-lg-2 mt-2 mt-lg-0">
                    <Button variant="outline-primary" size="lg" block onClick={startSigning}>Allkirjasta</Button>
                </div>
                ) : null
            }
            </div>
          </div>
      </div>
    );
}